    console.log('customymq1111')
    window.after_init_ymq_option = function () {
        console.log('customymq22222')
        // 设置提示内容
        const customizerTop = document.querySelectorAll('.customizer-top-content');
        const customizerBot = document.querySelectorAll('.customizer-bot-content');
        const topText =
          'Note: US Standard Sizing. Please verify measurements.<br/>Please note that the measurements on this size chart represent the dimensions of the clothing, not body measurements.<br/><span style="color: #D52A1A">Please refer to our size chart before order, the customized jerseys are special products. We don\'t accept cancel, change, return after order has been placed.</span>';

        const botText =
          'Use the chart above to determine your size. If you’re on the borderline between two sizes, order the smaller size for a tighter fit or the larger size for a looser fit. If your measurements for chest and waist correspond to two different suggested sizes, order the one indicated by your chest measurement.';
        const additionalText = `
  
          6XL: Ideal for slender individuals at high altitudes, offering a comfortable fit.<br/>
          7XL: Tailored for fuller figures, providing extra room and comfort.<br/><br/>
        `;
        // 设置 HTML 内容
        customizerTop.forEach((el) => {
          el.innerHTML = topText;
        });
        customizerBot.forEach((el) => {
          el.innerHTML = botText;
        });

        // 外层 tabs 和 panels：按模块分组处理，避免全局冲突
        document.querySelectorAll('.outer-tabs').forEach((tabGroup, groupIndex) => {
          const tabs = tabGroup.querySelectorAll('button');

          // 找到对应的 outer-panels 容器（确保顺序一致）
          const panelGroup = document.querySelectorAll('.outer-tab-panels')[groupIndex];
          if (!panelGroup) return;
          const panels = panelGroup.querySelectorAll('.tab-panel');

          tabs.forEach((tab, tabIndex) => {
            tab.addEventListener('click', () => {
              console.log(111111111111)
              // 当前组中清除 active
              tabs.forEach((btn) => btn.classList.remove('active'));
              panels.forEach((panel) => panel.classList.remove('active'));

              // 当前 tab、panel 加 active
              tab.classList.add('active');
              panels[tabIndex].classList.add('active');
            });
          });
        });

        // 内层 tab 切换（每个 outer-panel 内）
        document.querySelectorAll('.outer-tab-panels').forEach((panelGroup) => {
          panelGroup.querySelectorAll('.tab-panel').forEach((panel) => {
            const innerButtons = panel.querySelectorAll('.inner-tab-buttons button');
            const innerPanels = panel.querySelectorAll('.inner-tab-panel');

            innerButtons.forEach((btn, index) => {
              btn.addEventListener('click', () => {
                innerButtons.forEach((b) => b.classList.remove('active'));
                innerPanels.forEach((p) => p.classList.remove('active'));

                btn.classList.add('active');
                innerPanels[index].classList.add('active');
              });
            });
          });
        });
        document.querySelectorAll('.outer-tab-panels .tab-panel').forEach((panel) => {
      const innerButtons = panel.querySelectorAll('.inner-tab-buttons button');
      const innerPanels = panel.querySelectorAll('.inner-tab-panel');

      // 你的 HTML 结构中，第一个按钮/图片是 CM，第二个是 IN
      if (innerButtons.length >= 2 && innerPanels.length >= 2) {
        // 1. 移除可能存在的 IN 激活状态
        innerButtons[1].classList.remove('active');
        innerPanels[1].classList.remove('active');

        // 2. 强制赋予 CM 激活状态
        innerButtons[0].classList.add('active');
        innerPanels[0].classList.add('active');
      }
    });
      const maskImg = document.getElementById('imgPreviewMask'); // 遮罩层
const previewImg = document.getElementById('imgPreview'); // 预览图

// 状态变量
let scale = 1;
let translateX = 0;
let translateY = 0;
let isDragging = false;
let startX = 0;
let startY = 0;

// 🔄 核心：统一处理缩放和位移，防止互相覆盖
function updateImageTransform() {
  previewImg.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
}

// 1️⃣ 监听原图片点击，打开预览
document.querySelectorAll('.inner-tab-panel img, .kxk-slide img').forEach(img => {
  img.style.cursor = 'zoom-in';
  img.addEventListener('click', function () {
    previewImg.src = this.src;
    maskImg.style.display = 'flex';
    
    // 每次打开重置状态（回到居中和原始大小）
    scale = 1;
    translateX = 0;
    translateY = 0;
    previewImg.style.cursor = 'grab'; // 提示可拖拽
    updateImageTransform();
  });
});

// 2️⃣ 点击遮罩层关闭预览
maskImg.addEventListener('click', function (e) {
  // 确保点击的是遮罩背景，而不是图片本身
  if (e.target === maskImg) {
    maskImg.style.display = 'none';
    previewImg.src = '';
  }
});

// 3️⃣ 鼠标滚轮缩放
previewImg.addEventListener('wheel', function (e) {
  e.preventDefault(); // 阻止页面默认滚动

  const delta = e.deltaY > 0 ? -0.1 : 0.1;
  scale += delta;

  // 限制缩放范围 (0.2倍 到 5倍)
  scale = Math.min(Math.max(0.2, scale), 5);
  
  updateImageTransform();
}, { passive: false });

// 4️⃣ 鼠标按下：开始拖拽
previewImg.addEventListener('mousedown', function (e) {
  e.preventDefault(); // 🛑 极度关键：阻止浏览器默认的图片拖拽（避免出现半透明重影干扰）
  
  isDragging = true;
  previewImg.style.cursor = 'grabbing'; // 改变鼠标样式为“抓紧”
  
  // 记录鼠标按下时的起始坐标（需减去当前的偏移量）
  startX = e.clientX - translateX;
  startY = e.clientY - translateY;
});

// 5️⃣ 鼠标移动：更新图片位置
document.addEventListener('mousemove', function (e) {
  if (!isDragging) return;
  
  // 计算最新的 X 和 Y 偏移量
  translateX = e.clientX - startX;
  translateY = e.clientY - startY;
  
  updateImageTransform();
});

// 6️⃣ 鼠标松开：结束拖拽
document.addEventListener('mouseup', function () {
  if (isDragging) {
    isDragging = false;
    previewImg.style.cursor = 'grab'; // 恢复正常鼠标样式
  }
});
document.querySelectorAll('.inner-tab-panel img').forEach(function(img) {
    var currentSrc = img.src; 
    // console.log(currentSrc,999999996);
    
    if (currentSrc) {
      // 核心：用 split('?') 把链接从问号处劈开，[0] 代表只取问号前面的纯净 URL 部分
      // 这样就能自动把写死的旧 '?v=1756776080' 给剥离掉
      var baseUrl = currentSrc.split('?')[0]; 
      
      // 重新给 src 赋值，强制带上最新的毫秒级时间戳，打破缓存
      img.src = baseUrl + '?v=' + new Date().getTime();
    }
  });

    };
